import store from "@/state/store";
import PbxService from "./APIService/pbx.service";
import middlewares from "./middlewares";
import errorHandler from "./errorHandler";

/**
 * @param socket-response — Socket response required for proccess.
 * @returns — response based on there topic and socket response.
 */
const handleGatewaySocketResponse = (item, keyList) => {
  if (item == undefined || item == null) {
    return middlewares.notification(
      "Not able to proccess socket response !!",
      "info"
    );
  }
  let data = {
    event: "-",
    remark: "-",
    user_type: "-",
    key_info: "-",
    ...item,
  };
  if (item.topic == "ALARM") {
    Object.keys(item.payload).map((key) => {
      if (key == "unlock-by-rfid-alert") {
        data.event = "RFID Unlock";
        if (item.payload[key].status == "success") {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-success">${item.payload[key].status}</span></div> `;
        } else if (item.payload[key].status == "failed") {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-danger">${item.payload[key].status}</span></div> `;
        } else {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-info">${item.payload[key].status}</span></div> `;
        }
        data.user_type = item.payload[key].card_type;
        if (item.iot_key !== null) {
          data.key_info =
            keyList.length !== 0
              ? keyList.find((key) => key.id == item.iot_key)
              : "";
        }
      } else if (key == "latch-alert") {
        data.event = "Latch";
        if (item.payload[key] == true) {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-success">on</span></div> `;
        } else if (item.payload[key] == false) {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-danger">off</span></div> `;
        } else {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-info">unknown</span></div> `;
        }
      } else if (key == "deadbolt-alert") {
        data.event = "Deadbolt";
        if (item.payload[key] == true) {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-success">on</span></div> `;
        } else if (item.payload[key] == false) {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-danger">off</span></div> `;
        } else {
          data.remark = `<div><span class="badge align-items-center py-1 px-2 card-badge badge-soft-info">unknown</span></div> `;
        }
      } else {
        data.event = key;
      }
    });
  }
  if (item.topic == "CMD") {
    Object.keys(item.payload).map((key) => {
      data.event = item.payload["Command"];
      if (Object.keys(item.cmd_response).length !== 0) {
        if (data.event == "getstatus") {
          delete item.cmd_response.Response.master_data;
          delete item.cmd_response.Response.admin_key;
          delete item.cmd_response.Response.staff_key;
          delete item.cmd_response.Response.guest_key;
          delete item.cmd_response.Response.date_time;
        }
        Object.keys(item.cmd_response.Response).map((ikey) => {
          if (item.cmd_response.Command == "unlock") {
            data.remark = `<span>${item.cmd_response.Response[ikey]}</span>`;
          }
          if (item.cmd_response.Command == "getstatus") {
            let remarkStr = `<span class='me-2'>Status : ${item.cmd_response.Response["status"]}</span> `;
            remarkStr += `<span class='me-2'>Battery : ${item.cmd_response.Response["battery"]} %</span> `;
            remarkStr += `<span class='me-2'>Deadbolt : ${item.cmd_response.Response["deadbolt"]}</span> `;
            remarkStr += `<span class='me-2'>Latch : ${item.cmd_response.Response["latch"]}</span> `;
            remarkStr += `<span class='me-2'>Firmware Version : ${item.cmd_response.Response["firmware_version"]}</span> `;
            data.remark = remarkStr;
          }
        });
      }
    });
  }
  return data;
};

/**
 * @param domain — domain details to open pbx on that particuler domaim.
 */

const openPbxDomain = (data) => {
  if (data.domain_uuid !== null) {
    const mainUrl =
      window.location.host == "devapp.mycloudext.com"
        ? "https://pbx.guestxp.com/dashboard"
        : "http://localhost:8080/dashboard";
    let reciredUrl = `${mainUrl}?user_token=${store.state.auth.user.access}&domain_uuid=${data.domain_uuid}`;
    if (data.hotel_id) {
      reciredUrl += `&hotel_id=${data.hotel_id}`;
    }
    window.open(reciredUrl, "_blank");
  }
};

/**
 * @param number — number is used to get country code and number details.
 * @returns - simple phone number with country code and country code and is phone number validation
 */

const phoneNumberHandle = (number) => {
  const no_iso = number.country ? number.country.iso2 : "US";
  const isValid = number.valid ? number.valid : false;
  const no = number.countryCallingCode
    ? number.countryCallingCode + number.nationalNumber
    : "";
  return { number: no, valid: isValid, number_iso: no_iso };
};
/**
 * @param array  — original array which you want to make unique.
 * @param key  — pass key which you want use for make array unique.
 * @returns - unique array
 */

const uniqueArrayHandle = (original_array, unique_key) => {
  const uniqueArray = Array.from(
    original_array
      .reduce((map, obj) => map.set(obj[unique_key], obj), new Map())
      .values()
  );
  return uniqueArray;
};

const groupByArrayHandle = (original_array, unique_key) => {
  const uniqueArray = original_array.reduce((r, a) => {
    a.is_all =
      a.is_view && a.is_add && a.is_update && a.is_delete ? true : false;
    r[a[unique_key]] = [...(r[a[unique_key]] || []), a];
    return r;
  }, {});
  return uniqueArray;
};

export default {
  handleGatewaySocketResponse,
  openPbxDomain,
  phoneNumberHandle,
  uniqueArrayHandle,
  groupByArrayHandle,
};
